// Pixi rebuilds a whole render group when anything in it is added, removed or
// hidden, and re-packs every vertex of a subtree that moves.
export const MIN_ISOLATED_RENDERABLES = 50;

export const countRenderables = (container, limit = Infinity) => {
    let count = 0;
    const stack = [container];
    while (stack.length) {
        const node = stack.pop();
        if (node.renderPipeId && ++count >= limit) return count;
        const children = node.children;
        for (let i = 0; i < children.length; i++) stack.push(children[i]);
    }
    return count;
};

// Each render group costs a draw call, so only big groups get one, and the
// ones that change every frame: animation frames and parallax layers.
export const shouldIsolate = (sprite, {animation = false, parallax = false} = {}) => {
    if (!sprite || sprite.destroyed || sprite.isRenderGroup || !sprite.children?.length) return false;
    if (animation || parallax) return true;
    return countRenderables(sprite, MIN_ISOLATED_RENDERABLES) >= MIN_ISOLATED_RENDERABLES;
};
